import { CHANGE_AGENT_TAB } from "./types";

export const changeAgentTab = (viewType) => (dispatch) => {
    dispatch({
        type: CHANGE_AGENT_TAB,
        payload: viewType,
    });
};
